import { render } from "./IsleroLayout.vue?vue&type=template&id=20da620c&scoped=true"
import script from "./IsleroLayout.vue?vue&type=script&lang=js"
export * from "./IsleroLayout.vue?vue&type=script&lang=js"

import "./IsleroLayout.vue?vue&type=style&index=0&id=20da620c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20da620c"]])

export default __exports__